<template>
  <td class="moving text-center">
    <a
      v-if="moveUp"
      aria-label="Przesuń wiersz w górę"
      class="moveup mr-2"
      href="javascript:void(0)"
      title="W górę"
      tabindex="0"
      @click="moveRowUp()"
    >
      <i class="fas fa-arrow-up" />
    </a>

    <a
      v-if="moveDown"
      aria-label="Przesuń wiersz w dół"
      class="movedown mr-2"
      href="javascript:void(0)"
      title="W dół"
      tabindex="0"
      @click="moveRowDown()"
    >
      <i class="fas fa-arrow-down" />
    </a>

    <a
      v-if="deleteRow"
      aria-label="Usuń"
      class="delete"
      href="javascript:void(0)"
      title="Usuń"
      tabindex="0"
      @click="removeRow($event)"
    >
      <i class="fas fa-times" />
    </a>
  </td>
</template>

<script>
export default {
  name: 'WRowButtons',
  props: {
    model: {
      type: Object,
      required: true
    },
    deleteRow: {
      type: Boolean,
      default: true
    },
    moveUp: {
      type: Boolean,
      default: true
    },
    moveDown: {
      type: Boolean,
      default: true
    },
    confirmDeleteMessage: {
      type: String,
      default: 'Czy na pewno chcesz usunąć wiersz?'
    }
  },
  computed: {
    formParent: {
      get() {
        let parent = this.$parent;
        for (;;) {
          if (parent.form) {
            break;
          }

          if (parent.$parent) {
            parent = parent.$parent;
          }

          if (!parent.$parent) {
            parent = undefined;
            break;
          }
        }

        return parent;
      }
    }
  },

  methods: {
    moveRowUp() {
      this.model.$moveUp();
      this.$emit('rowMovedUp', this.model);
    },
    moveRowDown() {
      this.model.$moveDown();
      this.$emit('rowMovedDown', this.model);
    },
    removeRow(event) {
      const removeRow = () => {
        this.model.$removeRow();
        this.$emit('rowDeleted');
      };

      if (this.formParent && this.formParent.$listeners['before-row-delete']) {
        return new Promise((resolve, reject) => {
          this.formParent.$emit('before-row-delete', event, this.confirmDeleteMessage, resolve);
        }).then(result => {
          if (result) {
            removeRow();
          }
        });
      } else {
        removeRow();
      }
    }
  }
};
</script>
